import React, {ComponentProps, FC, ReactNode} from 'react';

import {ALIGN, Box, Layout as AuroraLayout, useDevice, View} from '@lookiero/aurora';
import {BoxPreviewStatus} from '@modules/box/core/projection/boxPreview/boxPreview';
import {OrderStatus} from '@domain/model/Order';
import {CheckoutProjection} from '@lookiero/checkout/dist/src/projection/checkout/checkout';
import {Stepper} from '../stepper/Stepper';
import {style} from './MyAreaOrderLayout.style';

export interface MyAreaOrderLayoutProps {
  readonly checkout?: CheckoutProjection | undefined;
  readonly orderStatus: keyof typeof OrderStatus | undefined;
  readonly orderNextBoxDate?: string;
  readonly boxPreviewStatus?: BoxPreviewStatus;
  readonly header?: ReactNode;
  readonly contentMarginTop?: ComponentProps<typeof Box>['marginTop'];
  readonly children: ReactNode;
}

const MyAreaOrderLayout: FC<MyAreaOrderLayoutProps> = ({
  checkout,
  orderStatus,
  orderNextBoxDate,
  boxPreviewStatus,
  header,
  contentMarginTop,
  children,
}) => {
  const {screen} = useDevice();

  return (
    <>
      <View style={[style.stepper, screen.L ? style.largeStepper : style.smallStepper]}>
        {header}
        <AuroraLayout fullWidth={!screen.L}>
          <Box size={{L: '1/3'}} align={ALIGN.CENTER}>
            <Stepper
              checkout={checkout}
              orderStatus={orderStatus}
              orderNextBoxDate={orderNextBoxDate}
              boxPreviewStatus={boxPreviewStatus}
              rounded={screen.L}
            />
          </Box>
        </AuroraLayout>
      </View>
      <AuroraLayout>
        <Box size={{L: '1/3'}} align={ALIGN.CENTER} marginTop={contentMarginTop}>
          {children}
        </Box>
      </AuroraLayout>
    </>
  );
};

export {MyAreaOrderLayout};
